<script>
  import Link from "../../../Navigation/Link/v1/Link.svelte";
  import Button from "../../../inputs/Button/v1/Button.svelte";

  /** @type {string} */
  export let description = "";
  /** @type {string} */
  export let title = "";
  /** @type {'h2'|'h3'|'h4'}*/
  export let headingLevel = "h2";
  /** @type {string} **/
  export let iconName = "default";
  /** @type {'vertical'|'horizontal'} */
  export let orientation = "vertical";
  /**  @type {'center'|'left'} */
  export let alignment = "center";
  /** @type {boolean} */
  export let showButton = false;
  /** @type {string} */
  export let buttonText = undefined;
  /** @type {'submit'|'button'|'reset'} */
  export let buttonHtmlType = "submit";
  /** @type {boolean} */
  export let showLink = false;
  /** @type {string} */
  export let linkText = undefined;
  /** @type {boolean} */
  export let showLoadingIndicator = false;
  /** @type {string} */
  export let href = "";
  /** @type {string} */
  export let target = '_self';

  let iconCssClass = "";
  let cssClass = "";

  $: {
    switch (iconName) {
      case "360reports":
      case "behaviour-overview":
      case "courses":
      case "default":
      case "empty-folder":
      case "events":
      case "files":
      case "follow-up-task":
      case "learning-objective":
      case "messages":
      case "news":
      case "notifications":
      case "plan-topics":
      case "plans":
      case "portfolio":
      case "project":
      case "question-category":
      case "search-no-result":
      case "test-questions":
      case "test-results":
      case "trash":
      case "user-groups":
      case "user":
        iconCssClass = `prom-empty-state__icon--${iconName}`;
        break;
      default:
        console.warn("Please provide proper icon iconName");
        iconCssClass = `prom-empty-state__icon--default`;
    }
  }

  $: if (!['h2', 'h3', 'h4'].some(l => l === headingLevel)) {
    console.warn("Valid heading levels are h2, h3 and h4");
  }

  $: if (showButton && !buttonText) {
    console.warn("Please provide button text");
  }

  $: if (showLink && !href) {
    console.warn("Please provide a valid url for the href attribute");
  }

  $: if (showLink && !linkText) {
    console.warn("Please provide a link text");
  }

  $: {
    if (orientation !== "horizontal" && orientation !== "vertical") {
      console.warn("Please provide a proper orientation");
    }

    if (orientation !== "vertical" && alignment !== "center") {
      console.warn(
        "Empty state does not support alignment for non-vertical state"
      );
    }

    if (orientation === "vertical" && alignment === "left") {
      cssClass = "prom-empty-state--aligned-left";
    } else {
      cssClass =
        orientation === "horizontal" ? `prom-empty-state--${orientation}` : "";
    }
  }
</script>

<section class="prom-empty-state {cssClass}">
  {#if showLoadingIndicator}
    <span class="prom-empty-state__icon prom-loading-spinner__spinner" />
  {:else}
    <span class="prom-empty-state__icon {iconCssClass}" />
  {/if}
  <div class="prom-empty-state__content-container">
    <svelte:element 
      this={headingLevel} 
      class="prom-empty-state__title">
      {title}
    </svelte:element>
    <p class="prom-empty-state__description">{description}</p>
    {#if showButton}
      <Button
        text={buttonText}
        type="primary"
        htmlType={buttonHtmlType}
        on:click
      />
    {:else if showLink}
      <Link {href} kind="standalone" text={linkText} {target} on:click />
    {/if}
  </div>
</section>
